module.exports = __webpack_public_path__ + "img/device-circle.8ee8950b.png";